import Vue from 'vue';

import noticeModal from './notice-modal.vue';

const NoticeModal = Vue.extend(noticeModal);

let instance;

const initInstance = (params) => {
  instance = new NoticeModal({
    el: document.createElement('div'),
    data: {
      dialogVisible: true,
      title: params.title,
      message: params.message,
      tips: params.tips,
      showCancelButton: params.showCancelButton,
      showConfirmButton: params.showConfirmButton,
      confirmButtonText: params.confirmButtonText,
      cancelButtonText: params.cancelButtonText,
      showClose: params.showClose || true,
      isTextareaMessage: params.isTextareaMessage,
    },
    methods: {
      cancelModal() {
        this.dialogVisible = false;
        params.cancelMethod();
      },
      confirmModal() {
        this.dialogVisible = false;
        params.confirmMethod();
      },
      closeModal() {
        params.cancelMethod && params.cancelMethod();
      },
    },
  });
};

const show = () => {
  // instance.$slots.default = [params.message];

  document.body.appendChild(instance.$el);
  Vue.nextTick(() => {
    instance.dialogVisible = true;
  });
};

const hide = () => {
  if (instance) {
    document.body.removeChild(instance.$el);
    instance = null;
  }
};

const modal = params => new Promise(() => {

  if (!instance) {
    initInstance(params);
  }

  show(params);

  instance.$watch('dialogVisible', (val) => {
    if (!val) {
      hide();
    }
  });
});

export default {
  modal,
};



// WEBPACK FOOTER //
// ./src/components/common/modals/notice-modal/notice-modal.js